import { IconButton } from '@ui/buttons/icon-button';
import { ArrowBackIcon } from '@ui/icons/material/ArrowBack';
import { useNavigate } from '@common/ui/navigation/use-navigate';
import { useTrans } from '@ui/i18n/use-trans';
import { message } from '@ui/i18n/message';

export function BackButton() {
  const navigate = useNavigate();
  const { trans } = useTrans();
  return (
    <IconButton
      size="md"
      className="mr-8"
      onClick={() => {
        if (window.history.length > 1) {
          navigate(-1);
        }
      }}
      aria-label={trans(message('Go back'))}
    >
      <ArrowBackIcon />
    </IconButton>
  );
}
